const FORM_TYPE = {
    email: 'email',
    emailCommunication: 'emailCommunication',
    application: 'application',
    shareable: 'shareable',
    noEmail: 'noEmail',
    selfService: 'selfService',
    triggerForm: 'triggerForm'
};

export const FORM_TYPE_OPTIONS = [
    {
        id: FORM_TYPE.email,
        description: 'Regular form with email notification'
    },
    {
        id: FORM_TYPE.application,
        description: 'Application or Acceptance form'
    },
    {
        id: FORM_TYPE.shareable,
        description: 'Public form for anyone on the web (not associated with students or employees)'
    },
    {
        id: FORM_TYPE.noEmail,
        description: 'Regular form with NO email notification'
    },
    {
        id: FORM_TYPE.selfService,
        description: 'Self-service form'
    },
    {
        id: FORM_TYPE.triggerForm,
        description: 'Trigger form'
    },
];

export const SETTINGS_FORM_TYPE_OPTIONS = [
    {
        id: FORM_TYPE.email,
        description: 'Regular form with email notification'
    },
    {
        id: FORM_TYPE.emailCommunication,
        description: 'Email communication'
    },
    ...FORM_TYPE_OPTIONS.filter(({id}) =>
        [
            FORM_TYPE.noEmail,
            FORM_TYPE.selfService,
            FORM_TYPE.triggerForm
        ].includes(id)
    )
];

export const getFormTypeTemplateFilters = (formType) => {
    switch (formType) {
        case FORM_TYPE.application:
            return {
                typeFilter: 'application',
                categoryFilter: null
            };
        case FORM_TYPE.shareable:
            return {
                typeFilter: 'shareable',
                categoryFilter: null
            };
        case FORM_TYPE.triggerForm:
            return {
                typeFilter: ['regular', 'offer', 'transition'],
                categoryFilter: null
            };
        default:
            return {
                typeFilter: null,
                categoryFilter: null
            };
    }
};

export const getFormBehaviorFromType = (formType) => ({
    allowMultipleSubmissions: formType === FORM_TYPE.selfService,
    enableRecipientNotifications: formType !== FORM_TYPE.noEmail,
    enableTrigger: formType === FORM_TYPE.triggerForm
});

export const getSettingsFormType = ({
    isCommunicationForm,
    allowMultipleSubmissions,
    enableTrigger,
    enableRecipientNotifications
}) => {
    if (isCommunicationForm) {
        return FORM_TYPE.emailCommunication;
    }

    if (enableTrigger) {
        return FORM_TYPE.triggerForm;
    }

    if (allowMultipleSubmissions) {
        return FORM_TYPE.selfService;
    }

    if (enableRecipientNotifications === false) {
        return FORM_TYPE.noEmail;
    }

    return FORM_TYPE.email;
};

export default FORM_TYPE;
